import { useQuery } from '@tanstack/react-query'
import cacheKeys from '@/services/cacheKeys'
import { adminRandomCheckInButtonStatus } from '..'

const useGetAdminRandomCheckInButtonStatus = () =>
  useQuery({
    queryKey: [cacheKeys.ADMIN_RANDOM_CHECK_IN_BUTTON_STATUS],
    queryFn: adminRandomCheckInButtonStatus,
  })

export default useGetAdminRandomCheckInButtonStatus
